import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
} from "adminlte-2-react";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import "react-phone-input-2/lib/style.css";
import Phone from "./../utils/Phone";
import { parseJwt, checkAuthorization } from "./../utils/utils";
import Loader from "../utils/Loader";

const { Select2, Text } = Inputs;

function CrearInvitacion({ history, match }) {
  const dispatch = useDispatch();

  const modelInvitacion = useSelector((state) => {
    return state.invitacion;
  });

  const modelOrganizaciones = useSelector((state) => {
    return state.organizaciones;
  });

  const [rol, setRol] = useState("admin");
  const [organizacionID, setOrganizacionID] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("+595");
  const [organizacionesForSelect, setOrganizacionesForSelect] = useState([]);
  const [rolCreador, setRolCreador] = useState(null);

  useEffect(() => {
    checkAuthorization(["superadmin", "admin"]);

    const token = localStorage.getItem("token");
    const decodedToken = parseJwt(token);
    if (
      decodedToken.organizacionID &&
      decodedToken.organizacionID !== "Particular" &&
      decodedToken.rol === "admin"
    ) {
      setOrganizacionID(decodedToken.organizacionID);
    }

    setRolCreador(decodedToken.rol);
  }, [dispatch]);

  useEffect(() => {
    //Supuestamente este useEffect con dependencias vacias es para ejecutar
    //al montar, tipo componentDidMount.

    dispatch(controller.getOrganizacionesThunk());
  }, []);

  useEffect(() => {

    const data = modelOrganizaciones?.data?.data;
    const error = modelOrganizaciones?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckGetOrganizaciones.actions.clear());
    }
    if (data) {
   
      setOrganizacionesForSelect(getListForSelect(data.data.lista));
      dispatch(controller.duckGetOrganizaciones.actions.clear());
    }
  }, [modelOrganizaciones]);

  useEffect(() => {
    const data = modelInvitacion?.data?.data;
    const error = modelInvitacion?.error;
    const errorCode = error?.response?.status;
    const errorMessage = modelInvitacion?.error?.response?.data?.mensaje;

    if (errorMessage) {
      alert(error);
    }
    if (error) {

      if (errorCode == 401) {
        dispatch(controller.duck.actions.clear());
        history.push("/logout");
      }
    }
    if (data) {
      alert("Creación exitosa");
      dispatch(controller.duck.actions.clear());
      history.goBack();
    }
  }, [modelInvitacion]);

  function doCrearInvitacion() {
   
    if (!rol || !organizacionID || !phone || !email) {
      alert("Por favor completar todos los campos");
      return;
    }
    const token = localStorage.getItem("token");
    const decodedToken = parseJwt(token);
    if (decodedToken.rol !== "superadmin" && decodedToken.rol !== "admin") {
      alert("Rol no autorizado");
      return;
    }

    let data = {
      rol: rol,
      organizacionID: organizacionID,
      userToken: token,
    };
    if (phone && phone !== "+") {
      data.phone = phone;
    }
    if (email) {
      data.email = email;
    }
    dispatch(controller.crearInvitacionThunk(data));
  }

  const getListForSelect = (data) => {
    if (data && data instanceof Array) {
      let resultado = data.map((element) => {
     
        return { value: element.id, label: element.nombre };
      });

      return resultado;
    }
    return [];
  };

  return (
    <Content
      title="Invitación"
      subTitle="Creación"
      browserTitle="Invitación"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Datos">
            {rolCreador === "superadmin" && (
              <Select2
                labelPosition="above"
                label="Organización"
                value={organizacionID}
                options={organizacionesForSelect}
                onChange={(e) => {
                  setOrganizacionID(e.target.value);
                }}
              />
            )}

            <Select2
              labelPosition="above"
              label="Rol"
              value={rol}
              options={[
                { value: "admin", label: "Admin" },
                { value: "visualizador", label: "Visualizador" },
              ]}
              onChange={(e) => setRol(e.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label="Correo electrónico"
              value={email}
              onChange={(evt) => setEmail(evt.target.value)}
            />

            <Phone value={phone} setValue={setPhone} international={false} />

            <Button
              type="primary"
              text={
                <Loader
                  loaderColor="#ffffff"
                  isLoading={modelInvitacion.loading}
                >
                  Crear
                </Loader>
              }
              pullRight={true}
              disabled={modelInvitacion.loading}
              onClick={() => doCrearInvitacion()}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default CrearInvitacion;
